export default __webpack_public_path__ + "static/media/misc-closetB-1024w.9bc3164a.png";